import { Skeleton, Typography } from 'antd'
import React, { Suspense } from 'react'

import { Trades } from './Trades'

export const TradesPage = () => {
  return (
    <>
      <Typography.Title>Trades</Typography.Title>

      <Suspense fallback={<Skeleton />}>
        <Trades />
      </Suspense>
    </>
  )
}
